import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b8e57cf8&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b8e57cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e57cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e57cf8')) {
      api.createRecord('b8e57cf8', component.options)
    } else {
      api.reload('b8e57cf8', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b8e57cf8&scoped=true&", function () {
      api.rerender('b8e57cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qsD63JvpkJec/JS/comp/GuestBox.vue"
export default component.exports